var _linearGradient, _linearGradient2, _linearGradient3, _rect, _rect2, _rect3, _rect4, _line, _line2, _circle, _circle2, _path, _rect5, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeSimulationJob48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "front_-45",
    "data-name": "front -45",
    x1: 45.75,
    y1: 1464.25,
    x2: 4.25,
    y2: 1422.75,
    gradientTransform: "translate(-2 -1424)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#999"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 41.5,
    y1: 1457.5,
    x2: 8.5,
    y2: 1424.5,
    gradientTransform: "translate(-2 -1419)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dark_Blue_Grad",
    "data-name": "Dark Blue Grad",
    x1: 26.161,
    y1: 26.161,
    x2: 43.838,
    y2: 43.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#73b4c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#6aaec3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#529eb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#2c839f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#147391"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 38,
    transform: "translate(46 39) rotate(180)",
    stroke: "#464646",
    strokeMiterlimit: 10,
    fill: "url(#front_-45)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 8.5,
    width: 39,
    height: 27,
    transform: "translate(46 44) rotate(180)",
    stroke: "#464646",
    strokeMiterlimit: 10,
    fill: "url(#linear-gradient)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 2.5,
    width: 4,
    height: 4,
    fill: "#73b4c8",
    stroke: "#147391",
    strokeMiterlimit: 10
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 2.5,
    width: 4,
    height: 4,
    fill: "#73b4c8",
    stroke: "#147391",
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38.5,
    y1: 2.5,
    x2: 42.5,
    y2: 6.5,
    fill: "#73b4c8",
    stroke: "#147391",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 42.5,
    y1: 2.5,
    x2: 38.5,
    y2: 6.5,
    fill: "#73b4c8",
    stroke: "#147391",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.999,
    cy: 35,
    r: 12.5,
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    fill: "url(#Dark_Blue_Grad)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.999,
    cy: 28.5,
    r: 2,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35,27a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,35,27m0-1a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,35,26Z",
    fill: "#147391"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 33.499,
    y: 32.5,
    width: 3,
    height: 11,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36,33V43H34V33h2m1-1H33V44h4V32Z",
    fill: "#147391"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeSimulationJob48);
export default __webpack_public_path__ + "static/media/typeSimulationJob48.e3d87df19bb6eb33c8719c30fd699fd8.svg";
export { ForwardRef as ReactComponent };